export const DEFAULT_SOURCING_TARGET_COUNTRY = 'CZE';
